import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ChevronDownSvg from '@/assets/ChevronDown.svg';
import ChevronDownDarkSvg from '@/assets/ChevronDownDark.svg';

interface ChevronDownProps extends IconProps {
  theme?: 'light' | 'dark';
}

const ChevronDown = ({ size, variant, className, theme = 'light' }: ChevronDownProps) => (
  <img
    src={theme === 'dark' ? ChevronDownDarkSvg : ChevronDownSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ChevronDown;
